import { MyFamilyProfile } from "./MyFamilyProfile/MyFamilyProfile";
import { useState } from "react";
import { MyFamilyCreationDialog } from "./MyFamilyCreationDialog/MyFamilyCreationDialog";
import { EmptyStateCard } from "../../../common/components/common/EmptyStateCard/EmptyStateCard";
import { IconType } from "../../../common/icons/Icon";
import { useApiQuery } from "../../../common/infrastructure/hooks/useApiQuery";
import { endpointsMetadata } from "../../../common/infrastructure/routes/endpointsMetadata";
import { IMyFamilyViewModel } from "./models/MyFamilyViewModel";
import styles from "./MyFamily.module.scss";

const FAMILY_HIGHLIGHTS = [
  "Записвайте членовете на семейството за класове и тренировки.",
  "Следете посещенията и абонаментите им на едно място.",
];

export const MyFamily = () => {
  const { data: familyData, isLoading } = useApiQuery<IMyFamilyViewModel>({
    queryKey: [endpointsMetadata.myFamily.getCurrentUserFamily],
    endpoint: endpointsMetadata.myFamily.getCurrentUserFamily,
    globalIsLoading: false,
  });

  const [showCreateFamilyDialog, setShowCreateFamilyDialog] = useState(false);

  if (!familyData && !isLoading) {
    return (
      <>
        <div className={styles.root}>
          <EmptyStateCard
            icon={IconType.Family}
            title={"Все още нямате семейство"}
            description={
              "Семейството събира вас и вашите близки в един профил, за да ги управлявате заедно."
            }
            highlights={FAMILY_HIGHLIGHTS}
            actionLabel={"Създаване на семейство"}
            onAction={() => setShowCreateFamilyDialog(true)}
          />
        </div>

        <MyFamilyCreationDialog
          visible={showCreateFamilyDialog}
          onClose={() => setShowCreateFamilyDialog(false)}
        />
      </>
    );
  }

  return <MyFamilyProfile familyData={familyData} isLoading={isLoading} />;
};
